import { Play, Pause, Heart, MusicNotes } from "@phosphor-icons/react";

function fmt(s) {
  if (!s) return null;
  const m = Math.floor(s / 60);
  const r = Math.floor(s % 60);
  return `${m}:${r.toString().padStart(2, "0")}`;
}

const SOURCE_LABEL = {
  jamendo: { tag: "JAMENDO", color: "#09e7ff" },
  archive: { tag: "ARCHIVE", color: "#ff7a18" },
  youtube: { tag: "YOUTUBE", color: "#ff3d1e" },
};

export default function TrackCard({ track, onPlay, onFav, isFav, isPlaying }) {
  const sourceMeta = SOURCE_LABEL[track.source] || { tag: track.source?.toUpperCase() || "MP3", color: "#14f1d9" };
  return (
    <div
      data-testid="mp3-track-card"
      data-source={track.source}
      className={`group glass-card overflow-hidden flex min-w-0 transition-all duration-200 hover:-translate-y-1 ${isPlaying ? "border-orange-400/70 shadow-[0_0_28px_rgba(255,77,29,.22)]" : "hover:border-cyan-300/30"}`}
    >
      <div className="relative w-28 sm:w-36 min-h-[110px] shrink-0 bg-[#07111d] overflow-hidden">
        {track.artwork ? (
          <img
            src={track.artwork}
            alt=""
            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
            loading="lazy"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center recho-fallback-art">
            <MusicNotes size={34} weight="duotone" color="#09e7ff" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/5 to-transparent" />
        <span className="absolute top-2 left-2 rounded-lg font-mono text-[8px] uppercase tracking-wider px-2 py-1 text-white border border-white/20 bg-black/40 backdrop-blur">
          {sourceMeta.tag.slice(0, 3)}
        </span>
        <button
          data-testid="mp3-play-button"
          onClick={() => onPlay?.(track)}
          aria-label={isPlaying ? "Pause" : "Play"}
          className={`absolute right-2 bottom-2 w-10 h-10 rounded-full flex items-center justify-center border border-white/30 backdrop-blur transition-colors ${isPlaying ? "bg-[#ff4d1d] text-white" : "bg-black/40 text-white hover:bg-[#ff4d1d] hover:border-[#ff4d1d]"}`}
        >
          {isPlaying ? <Pause size={16} weight="fill" /> : <Play size={16} weight="fill" />}
        </button>
      </div>

      <div className="flex-1 min-w-0 p-4 flex flex-col justify-center">
        <div className="font-serif-display text-lg sm:text-xl font-semibold leading-tight text-white truncate" title={track.title}>
          {track.title || "Untitled"}
        </div>
        <div className="font-sans text-xs sm:text-sm text-slate-300/75 truncate mt-1" title={track.artist || "Unknown artist"}>
          {track.artist || "Unknown artist"}
        </div>
        <div className="font-mono text-[9px] uppercase tracking-[0.14em] text-slate-400 mt-3 flex items-center gap-2 min-w-0">
          <span className="px-2 py-1 rounded-lg border shrink-0" style={{ color: sourceMeta.color, borderColor: `${sourceMeta.color}66`, backgroundColor: `${sourceMeta.color}14` }}>
            {sourceMeta.tag}
          </span>
          {fmt(track.duration) && <span className="shrink-0">{fmt(track.duration)}</span>}
          {track.album && <span className="truncate min-w-0">· {track.album}</span>}
        </div>
      </div>

      <div className="flex items-center pr-3 shrink-0">
        <button
          data-testid="mp3-fav-button"
          onClick={(e) => { e.stopPropagation(); onFav?.(track); }}
          aria-label={isFav ? "Remove favorite" : "Add favorite"}
          className={`w-10 h-10 rounded-full border border-white/10 flex items-center justify-center transition-colors ${isFav ? "text-[#ff4d1d] bg-[#ff4d1d]/10" : "text-slate-300/60 hover:text-[#ff4d1d] hover:border-[#ff4d1d]/60"}`}
        >
          <Heart size={18} weight={isFav ? "fill" : "regular"} />
        </button>
      </div>
    </div>
  );
}
